export default __webpack_public_path__ + "static/media/ic-playlist.27dc92c4.svg";